const propertiesFromRenderer = renderedObject => ({
    height: renderedObject.height,
    width: renderedObject.width
});

module.exports = {
    propertiesFromRenderer
};
